import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { type ReactNode, useMemo } from 'react';
import { theme } from './theme';
import darkPalette from './theme/paletteDark';
import lightPalette from './theme/paletteLight';

const THEME_MODE_KEY = 'GRIDOS:CONNECT:themeMode';
const THEMES = { DARK: 'dark', LIGHT: 'light' };

interface ThemeProviderProps {
  isDarkMode: boolean;
  children: ReactNode;
}

const ThemeProvider = ({ isDarkMode = true, children }: ThemeProviderProps) => {
  const currentTheme = useMemo(() => {
    const newTheme = isDarkMode ? theme(darkPalette) : theme(lightPalette);
    localStorage.setItem(THEME_MODE_KEY, isDarkMode ? THEMES.DARK : THEMES.LIGHT);
    return newTheme;
  }, [isDarkMode]);
  return (
    <MuiThemeProvider theme={currentTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
